import React, { useState, useEffect } from 'react';
import DOMPurify from "dompurify";
import axios from "axios";

function AboutUs() {
    const [pageContent, setPageContent] = useState([]);
    const [moduleContent4, setModuleContent4] = useState([]);
    const [moduleContent5, setModuleContent5] = useState([]);
    const [moduleContent6, setModuleContent6] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSPage/GetPageContentById/248`)
            .then((response) => {                
                setPageContent(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/4`)
            .then((response) => {                
                setModuleContent4(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/5`)
            .then((response) => {                
                setModuleContent5(response.data);
            });
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSModule/GetPageModuleContentById/6`)
            .then((response) => {                
                setModuleContent6(response.data);
            });
    }, []);

    const leftContentHTML = DOMPurify.sanitize(pageContent.pgS_T_OTHERPAGECONTENT2);
    const rightImageHTML = DOMPurify.sanitize(pageContent.pgS_T_PAGECONTENT);
    const mContent4 = DOMPurify.sanitize(moduleContent4.pmC_V_MODULECONTENT);
    const mContent5 = DOMPurify.sanitize(moduleContent5.pmC_V_MODULECONTENT);
    const mContent6 = DOMPurify.sanitize(moduleContent6.pmC_V_MODULECONTENT);

    return (
        <div>
            <section id="about-index">
                <div class="container">
                    <div class="section-heading text-center"><br /><br />
                        <h2>About Us</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-lg-7 text-center">
                            <div dangerouslySetInnerHTML={{ __html: leftContentHTML }} />
                            <div class="panel-group" id="accordion">
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">{moduleContent4.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseOne" class="panel-collapse collapse in">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent4 }} />
                                        </div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">{moduleContent5.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseTwo" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent5 }} />
                                        </div>
                                    </div>
                                </div>
                                <div class="panel">
                                    <div class="panel-heading">
                                        <h5 class="panel-title">
                                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree">{moduleContent6.pmC_V_MODULENAME}</a>
                                        </h5>
                                    </div>
                                    <div id="collapseThree" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div dangerouslySetInnerHTML={{ __html: mContent6 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div className='img-container' dangerouslySetInnerHTML={{ __html: rightImageHTML }} />                           
                        </div>                        
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutUs;